import { render, staticRenderFns } from "./MaskedLoading.vue?vue&type=template&id=8454da58&scoped=true"
import script from "./MaskedLoading.vue?vue&type=script&lang=ts"
export * from "./MaskedLoading.vue?vue&type=script&lang=ts"
import style0 from "./MaskedLoading.vue?vue&type=style&index=0&id=8454da58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8454da58",
  null
  
)

export default component.exports